import { InfoIcon } from "lucide-react";
import React, { ReactNode } from "react";

type StageHeaderHighlightProps = {
  children: ReactNode;
};

const StageHeaderHighlight = ({ children }: StageHeaderHighlightProps) => (
  <div className="text-destructive mt-6 flex gap-2 rounded-sm bg-[#0093D012] px-3 py-4.5 text-left text-sm">
    <InfoIcon size={15} className="mt-1 shrink-0" />
    {children}
  </div>
);

export default StageHeaderHighlight;
